import { InjectionToken } from '@angular/core';
import Swal from 'sweetalert2';

export const SWAL = new InjectionToken<typeof Swal>('SweetAlert2 Token');
